var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import QuestionnaireOrg from "../../../organisms/obligationsQuestionnaire/obligationsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdviserAdviserObligationsAction, AdviserAdviserObligationsFormAction, } from "../../../../redux/actions/adviser_questionnaire";
import { forceBlrRecalculation } from "../../../../redux/actions/manage_users";
import { getAdviserQuestionnaireProgressWidth } from "../../../../utils/questionnaireProgress";
/**
 * The Adviser Adviser Obligations Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function AdviserAdviserObligationsQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(''), error = _a[0], setError = _a[1];
    //using selector hook to fetch data from the reducer
    var _b = useSelector(function (state) { return state.rootReducer.AdviserQuestionnaireReducer; }), adviserAdviserObligationsData = _b.adviserAdviserObligationsData, error_adviserAdviserObligationsl = _b.error_adviserAdviserObligationsl, loading = _b.loading, adviserAdviserObligationsFormData = _b.adviserAdviserObligationsFormData, success_adviserAdviserObligations_form = _b.success_adviserAdviserObligations_form;
    useEffect(function () {
        // Adviser Progression prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!adviserAdviserObligationsData || adviserAdviserObligationsData.length === 0) {
            dispatch(AdviserAdviserObligationsAction());
        }
    }, [dispatch]);
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    // Get the viewing_username (the jobseeker being viewed by the adviser)
    var viewing_username = useSelector(function (state) { return state.rootReducer.dashboardReducer.viewing_username; });
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    var isSecondAttempt = !!(quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.adv_questionnaire_one_complete);
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        dispatch(AdviserAdviserObligationsFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        navigate("/questionnaire/adviserClientObligations");
    };
    if (success_adviserAdviserObligations_form) {
        dispatch(forceBlrRecalculation());
        if (viewing_username) {
            // If viewing a specific jobseeker, navigate to their dashboard
            navigate("/dashboard", { state: { viewUser: viewing_username } });
        }
        else {
            // Default navigation to adviser's own dashboard
            navigate("/dashboard");
        }
    }
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Adviser Expectations", content: "As an adviser on this programme, you will be interacting with your customer on a regular basis. In order to ensure that you get the best from the relationship with your customer, we want to understand what you feel you have committed to do, but also what they have committed to do, to develop their employability. Please respond truthfully and trust your initial reactions to the following statements.", data: adviserAdviserObligationsData, responses: adviserAdviserObligationsFormData, loading: !adviserAdviserObligationsData || adviserAdviserObligationsData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "global-w", width: getAdviserQuestionnaireProgressWidth("adviserAdviserObligations", isSecondAttempt) })] })));
}
export default AdviserAdviserObligationsQuestionnaire;
